/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
	{},
	{
		[actions.REPORTS_RECEIVE]: (state, action) => {
			return reduce(
				action.payload.reports,
				(memo, report) => {
					const { id } = report;
					if (memo === state) {
						memo = { ...memo };
					}
					memo[id] = report;
					return memo;
				},
				state,
			);
		},
		[actions.DELETE_REPORT_SUCCESS]: (state, action) => {
			const reportId = get(action, ['payload', ['reportId']]);
			const items = { ...state };
			return omitBy(items, { id: reportId });
		},
	},
);
